module.exports = __webpack_public_path__ + "img/user-white.51508abf.svg";